<template>

  <div class="row" v-if="Orders">
    <div class="col-6 card col-laptop-12">
      <div class="row justify-content-space-between">
        <strong class="col-11 card-title"><span class="icon-Bookmark"></span>Услуги</strong>
      </div>
      <div class="row ">
        <div class="col-12">
          <small>Остаток на счёте:</small><br>
          <strong v-if="Contracts">{{ ContractsAmount }} руб. </strong>
          <strong v-else>Загрузка...</strong>
          <br>

        </div>

        <div class="col-12">
          <div class="text-field">
            <label class="text-field__label" for="search">Наименование договора</label>
            <div class="row">
              <div class="col-12 text-field__icon">
                <input class="text-field__input" type="search" name="search" id="search"  disabled="True" value="Приём отходов в тоннах">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row top-24">
        <router-link to="/polygon/contracts" class="col-12 btn-primary"><span class="icon-DownloadSimple"></span>Все договоры</router-link>
      </div>
    </div>

    <div class="col-6 card col-laptop-12">
      <div class="row justify-content-space-between">
        <strong class="col-7 card-title"><span class="icon-ArrowRight"></span>Запланировано</strong>
<!--        <router-link v-if="NewOrders.length > 2" to="/polygon/planned" class="col-5" style="text-align: right; font-size: 12px;">-->
<!--          Все запланированные ({{-->
<!--            NewOrders.length }})-->
<!--        </router-link>-->
      </div>
      <div class="row">
        <table width="100%" v-if="ordersList && LatestNewOrders.length">
          <tbody>
          <tr class="bottom" v-for="order in LatestNewOrders">
            <td >
              <small style="margin-left: 4px;">Заявка <b>№{{ order.OrderID }}</b> </small><br>
              <small style="margin-left: 4px;">Регистрационный номер автомобиля: <b>{{ order.OrderCar }}</b> </small><br>
              <small style="margin-left: 4px;">Водитель: <b>{{ order.OrderDriver }}</b> </small><br>
<!--              <router-link v-if="canCopyOrder" :to="{-->
<!--                    name: 'new_order',-->
<!--                    query: {-->
<!--                      previous_OrderCar: order.OrderCar,-->
<!--                      previous_OrderDriver: order.OrderDriver,-->
<!--                      previous_OrderContract: order.ContractID || order.OrderContract || order.Contract || '',-->
<!--                      previous_WasteTypes: order.WasteTypes,-->
<!--                      previous_WasteProcents: (order.WasteProcents || []).map(p => Number(p).toFixed(3))-->
<!--                    } }">-->
<!--                <small class="gray btn-primary" style="font-size: 8px; padding: 0.8em"> Копировать заявку </small>-->
<!--              </router-link>-->
                  <router-link :to="{
                        name: 'new_order',
                        query: {
                          previous_OrderCar: order.OrderCar,
                          previous_OrderDriver: order.OrderDriver,
                          previous_OrderContract: order.ContractID || order.OrderContract || order.Contract || '',
                          previous_WasteTypes: order.WasteTypes,
                          previous_WasteProcents: (order.WasteProcents || []).map(p => Number(p).toFixed(3))
                        } }">
                    <small class="gray btn-primary" style="font-size: 8px; padding: 0.8em"> Копировать заявку </small>
                  </router-link>
              <router-link :to="{
                    name: 'edit_order',
                    query: {
                      previous_OrderID: order.OrderID,
                      previous_OrderDate: order.OrderDate,
                      previous_OrderCar: order.OrderCar,
                      previous_OrderDriver: order.OrderDriver,
                      previous_OrderContract: order.ContractID || order.OrderContract || order.Contract || '',
                      previous_WasteTypes: order.WasteTypes,
                      previous_WasteProcents: (order.WasteProcents || []).map(p => Number(p).toFixed(3))
                    } }">
                <small class="gray btn-primary" style="font-size: 8px; padding: 0.8em; margin-left: 4px;"> Изменить заявку </small>
              </router-link>
            </td>
            <td style="text-align: center;">
              <small class="green" style="position: relative;">{{ format_date(order.OrderDate) }}</small>
            </td>
          </tr>
          </tbody>
        </table>
        <div class="col-12" v-else>
          Запланированные визиты на полигон пока отсутствуют.
        </div>
      </div>
      <!-- <div class="row top-24">
        <button class="col-6 btn-primary"><span class="icon-DownloadSimple"></span></button>
        <button class="col-6 btn-secondary" @click="clickCam('192.168.178.147')"><span class="icon-Camera"></span>Камера</button>
      </div> -->
      <div class="row top-24">
        <router-link to="/polygon/new_order" class="col-12 btn-primary"><span class="icon-Plus"></span>Заявка на прием отходов</router-link>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-8 card col-laptop-12">
      <div class="row justify-content-space-between">
        <strong class="col-5 card-title">Вес отгрузки по дням
          <br><small v-if="this.datefilter[0]">c {{ format_date(this.datefilter[0], 'date') }} по {{ format_date(this.datefilter[1], 'date') }}</small>
        </strong>
      </div>
      <div class="col-12">
        <div>
          <table width="100%" v-if="OldOrders.length" class="weight-table">
            <thead>
            <tr>
              <th scope="col" style="text-align: left; padding: 8px; white-space: nowrap;">Дата</th>
              <th scope="col" style="text-align: center; padding: 8px; white-space: nowrap;">Номер заявки</th>
              <th scope="col" style="text-align: center; padding: 8px; white-space: nowrap;">Госномер авто</th>
              <th scope="col" style="text-align: right; padding: 8px; white-space: nowrap;">Вес (кг)</th>
            </tr>
            </thead>
            <tbody>
            <tr class="bottom" v-for="order in OldOrders"
                :key="order.OrderID"
            >
              <td style="padding: 8px; white-space: nowrap;">
                <small>{{ format_date(order.OrderDate, 'date') }}</small>
              </td>
              <td style="text-align: center; padding: 8px; white-space: nowrap;">
                <small>№{{ order.OrderID }}</small>
              </td>
              <td style="text-align: center; padding: 8px; white-space: nowrap;">
                <small>{{ order.OrderCar }}</small>
              </td>
              <td style="text-align: right; padding: 8px; white-space: nowrap;">
                <small>{{ Change(order.OrderWeight) }}</small>
              </td>
            </tr>
            </tbody>
          </table>
          <div v-else>
            За период не было выполненных рейсов с указанным весом
          </div>
        </div>
      </div>
    </div>
    <div class="col-4 card col-laptop-12">
      <div class="row justify-content-space-between">
        <strong class="col-8 card-title">История рейсов</strong>
        <!--        <p>222</p>-->
      </div>

      <div class="col-12">
        <div style="overflow: auto; height: 500px;" v-if="OldOrders">
          <table width="100%" >

            <tbody >
            <tr class="bottom" v-for="order in OldOrders">
              <td >
                <small>Рейс по заявке {{ order.OrderID }} от {{ format_date(order.OrderDate) }}</small><br>

                <small class="gray"> {{ order.OrderCar }}</small><br>
                <small class="gray"> {{ Change(order.OrderWeight) }} кг</small>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          Рейсы отсутствуют
        </div>
        <div class="row top-24">
          <router-link to="/polygon/history" class="col-12 btn-primary"><span class="icon-DownloadSimple"></span>Подробнее</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import byBatchs from "@/components/Dashbord/HomeFactory/byBatchs.vue";
import byTotal from "@/components/Dashbord/HomeFactory/byTotal.vue";
// import VueSpeedometer from "vue-speedometer"
import DashChart from "@/components/Dashbord/DashChart.vue";
import ProgressBar from "@/components/Shared/ProgressBar.vue";
import moment from 'moment'

export default {
  components: { DashChart, ProgressBar },
  data() {
    return {
      datefilter: [this.week_ago(), this.today_date()],
      styles: {
        padding: "15px",
        height: "150px",
      },
      showSearch: false,
      title: "Дашборд",
      options: {
        chart: {
          id: 'vuechart-example'
        },
        stroke: {
          curve: 'smooth',
          colors: ['#F26650', '#000000'],
        },
        dataLabels: {
          enabled: false
        },
        fill: {
          colors: ['#F26650', '#000000'],
          type: 'solid',
          opacity: 0.1,
        },
        xaxis: {
          categories: [20, 21, 22, 23, 24, 25, 26]
        }
      },
      series: [
        {
          name: 'Руб.',
          color: '#F26650',
          data: [20, 0, 5, 18, 0, 20, 0]
        },
      ]
    }
  },
  beforeMount() { document.title = this.title },
  computed: {
    canCopyOrder() {
      const allowedINNs = ['5257084971', '5837067698', '5260462711', '5257016604'];
      const userINN = String(this.currentUser.company_inn);
      console.log('HomePoligon - User INN:', userINN, 'Type:', typeof this.currentUser.company_inn);
      console.log('HomePoligon - Can copy:', allowedINNs.includes(userINN));
      return allowedINNs.includes(userINN);
    },
    OldOrders() {
      const today = moment().startOf('day');
      const hasRange = Array.isArray(this.datefilter) && this.datefilter.length >= 2;
      const start = hasRange ? moment(this.datefilter[0]).startOf('day') : moment(-8640000000000000);
      const end   = hasRange ? moment(this.datefilter[1]).endOf('day')   : moment( 8640000000000000);

      return (this.$store.state.polygon_orders?.Orders || [])
          .filter((order) => {
            const orderDate = moment(order.OrderDate);
            const isOldOrder =
                order.OrderStatus === true || orderDate.isBefore(today);

            const w = Number(order.OrderWeight);
            const hasWeight = Number.isFinite(w) && w > 0;

            const inRange = orderDate.isSameOrAfter(start) && orderDate.isSameOrBefore(end);

            return isOldOrder && hasWeight && inRange;
          })
          .sort((a, b) => new Date(b.OrderDate) - new Date(a.OrderDate));
    },

    currentUser() {
      return this.$store.state.auth.user;
    },
    Contracts() {
      return this.$store.state.polygon_company.Contracts
    },
    ContractsAmount() {
      return this.Change(this.$store.state.polygon_company.Contracts.reduce((acc, item) => acc + item['Amount'], 0))
    },
    Orders() {
      return this.$store.state.polygon_orders
    },
    ordersList() {
      const orders = this.$store.state.polygon_orders?.Orders || [];

      // Дополняем данные из localStorage
      const savedOrders = JSON.parse(localStorage.getItem('orderDetails') || '{}');

      return orders.map(order => {
        const savedData = savedOrders[order.OrderID];
        if (savedData) {
          return {
            ...order,
            ContractID: savedData.ContractID || order.ContractID || '',
            WasteTypes: savedData.WasteTypes || order.WasteTypes || [],
            WasteProcents: savedData.WasteProcents || order.WasteProcents || []
          };
        }
        return order;
      });
    },
    NewOrders() {
      const today = moment().startOf('day');

      const filtered = this.ordersList.filter((order) => {
        const isStatusFalse = order.OrderStatus === false;
        const orderDate = moment(order.OrderDate);
        const isTodayOrFuture = orderDate.isSameOrAfter(today);

        return isStatusFalse && isTodayOrFuture;
      });
      return filtered.sort((a, b) => new Date(a.OrderDate) - new Date(b.OrderDate));
    },
    LatestNewOrders() {
      return this.NewOrders.slice(0, 2);
    },
  },
  methods: {
    format_date(value, time='NaN'){
      if (value) {
        if (time != 'NaN') {
          return moment(String(value)).format('DD.MM.YYYY')
        } else {
          return moment(String(value)).format('DD.MM.YYYY HH:mm')
        }
      }
    },
    today_date(){
      return moment().format('YYYY-MM-DD');
    },
    yesterday_date(){
      return moment().subtract(1, 'days').format('YYYY-MM-DD');
    },
    week_ago(){
      return moment().subtract(7, 'days').format('YYYY-MM-DD');
    },
    month_ago(){
      return moment().subtract(30, 'days').format('YYYY-MM-DD');
    },
    month_next(){
      return moment().add(30, 'days').format('YYYY-MM-DD');
    },
    Change(number) {
      number = Math.trunc(number);
      return number.toString().replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, '$1 ');
    },
  },
  created() {
    this.$store.dispatch("fetchPolygonContracts", this.currentUser.company_inn);
    this.$store.dispatch("fetchPolygonOrders", {
      inn: this.currentUser.company_inn,
      start_date: this.month_ago(),
      end_date: this.month_next()
    });
  },
  beforeUnmount() {}
};
</script>

<style scoped>
.col-8 {
  width: calc(100% / 12 * 8 - 30px);
}
.weight-table {
  border-collapse: collapse;
  width: 100%;
}

.weight-table th {
  background-color: #f8f9fa;
  font-weight: bold;
  border-bottom: 2px solid #dee2e6;
}

.weight-table td {
  border-bottom: 1px solid #dee2e6;
  vertical-align: middle;
}

.weight-table tr:last-child td {
  border-bottom: none;
}

.weight-table small {
  font-size: 12px;
}
</style>